import { Component } from '@angular/core';

@Component({
    selector: 'unsubscribe',
    template: `<router-outlet></router-outlet>`,
    standalone: false
})
export class UnsubscribeComponent {}
